import { render, staticRenderFns } from "./OTP-verified.vue?vue&type=template&id=3cc40702&"
import script from "./OTP-verified.vue?vue&type=script&lang=js&"
export * from "./OTP-verified.vue?vue&type=script&lang=js&"
import style0 from "./OTP-verified.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports